var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplitHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 482,
    height: 436,
    viewBox: "0 0 482 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.862 8.07008C175.723 8.07008 212.146 27.788 227.721 41.6147V419.779C169.644 375.77 111.593 328.99 70.6238 282.184C26.6688 231.907 6.8164 187.226 8.13451 141.522L8.18831 139.29C12.5461 29.0254 99.3264 11.7285 116.785 9.36129L117.242 9.30749C122.999 8.50048 128.944 8.07008 134.889 8.07008M134.862 0C128.728 0 122.434 0.403504 116.085 1.31811C110.624 2.09822 3.74977 14.2033 0.0644316 141.28C-2.8946 242.936 96.3673 331.223 235.764 435.946V38.1177C221.749 24.1833 181.937 0 134.862 0Z",
    fill: "#C0EC5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4677 127.779C28.2277 147.951 68.5781 139.882 127.759 118.362C79.3382 130.027 41.6779 95.4961 17.4677 127.779Z",
    fill: "#DCEFB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.673 403.426C88.4809 302.684 13.8058 225.642 16.2268 141.74L16.3075 139.158C16.4689 135.069 16.7648 131.061 17.1683 127.16C85.199 147.954 158.72 80.7041 219.673 127.052V403.426Z",
    fill: "#C0EC5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M346.422 8.07008C305.561 8.07008 269.138 27.788 253.563 41.6147V419.779C311.64 375.77 369.691 328.99 410.66 282.184C454.615 231.907 474.468 187.226 473.149 141.522L473.096 139.29C468.738 29.0254 381.958 11.7285 364.499 9.36129L364.042 9.30749C358.285 8.50048 352.34 8.07008 346.395 8.07008M346.422 0C352.556 0 358.85 0.403504 365.199 1.31811C370.659 2.09822 477.534 14.2033 481.22 141.28C484.179 242.936 384.917 331.223 245.519 435.946V38.1177C259.535 24.1833 299.347 0 346.422 0Z",
    fill: "#C0EC5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M463.816 127.779C453.056 147.951 412.706 139.882 353.525 118.362C401.946 130.027 439.606 95.4961 463.816 127.779Z",
    fill: "#DCEFB2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M261.611 403.426C392.803 302.684 467.478 225.642 465.057 141.74L464.976 139.158C464.815 135.069 464.519 131.061 464.116 127.16C396.085 147.954 322.564 80.7041 261.611 127.052V403.426Z",
    fill: "#C0EC5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitHeart);
export default __webpack_public_path__ + "static/media/splitHeart.8c06b2fdeabc844d3ba68ed37d440207.svg";
export { ForwardRef as ReactComponent };